export enum ContractStatus {
  DRAFT = 'DRAFT',
  SENT = 'SENT',
  OPEN = 'OPEN',
  CONFIRMED = 'CONFIRMED',
  CANCELLED = 'CANCELLED'
}
